import React from "react";
import { useTranslation } from "react-i18next";
import "./Cgv.css";

const ARTICLES_FR = [
  {
    num: 1,
    title: "Identification",
    blocks: [
      {
        type: "p",
        text: "Les présentes Conditions générales d'adhésion (ci-après les « Conditions ») régissent les adhésions proposées sous la marque ACE Fund par :",
      },
      {
        type: "address",
        lines: [
          "ACE Good SRL",
          "Société à responsabilité limitée de droit belge",
          "N° d'entreprise / TVA : BE 0776.527.659",
          "Siège social : Rue Fortemps de Loneux 25, 4000 Liège, Belgique",
          "Ci-après « ACE Fund », « ACE Good » ou « nous ».",
        ],
      },
      {
        type: "p",
        text: "Les coordonnées électroniques de contact et, le cas échéant, les autres informations légales sont disponibles sur le site www.acefund.io (le « Site »).",
      },
    ],
  },
  {
    num: 2,
    title: "Objet",
    blocks: [
      {
        type: "p",
        text: "Les présentes Conditions déterminent les droits et obligations applicables à la souscription et à l'utilisation des différentes formules d'adhésion ACE Fund.",
      },
      {
        type: "p",
        text: "Selon la formule choisie, l'adhésion peut notamment permettre au membre :",
      },
      {
        type: "ul",
        items: [
          "d'accéder à la plateforme ACE Fund et à certains contenus, informations et services réservés aux membres ;",
          "de participer à des événements, rencontres, activités ou services proposés par ACE Fund ;",
          "de bénéficier des avantages correspondant à la formule d'adhésion choisie ;",
          "de prendre connaissance d'opportunités d'investissement proposées ou présentées sur la plateforme ;",
          "lorsque cela est prévu par la formule concernée, d'accéder à certaines opportunités ou structures d'investissement, sous réserve de satisfaire aux conditions spécifiques applicables à celles-ci.",
        ],
      },
      {
        type: "p",
        text: "Le contenu exact, les avantages, le prix et les éventuelles conditions particulières de chaque formule sont ceux présentés sur le Site au moment de la souscription.",
      },
    ],
  },
  {
    num: 3,
    title: "Distinction entre l'adhésion et les investissements",
    blocks: [
      {
        type: "p",
        text: "L'adhésion à ACE Fund et la réalisation d'un investissement constituent deux opérations juridiquement distinctes.",
      },
      {
        type: "p",
        text: "Le paiement d'une adhésion ne constitue en aucun cas un investissement, une souscription à un instrument financier ou une remise de fonds destinée à être investie.",
      },
      {
        type: "p",
        text: "L'adhésion peut permettre au membre d'accéder à des informations relatives à certaines opportunités d'investissement. Cet accès ne confère toutefois aucun droit automatique de participer à une opération déterminée.",
      },
      {
        type: "p",
        text: "Toute opération d'investissement est susceptible d'être soumise notamment :",
      },
      {
        type: "ul",
        items: [
          "à des conditions d'éligibilité propres ;",
          "à des seuils minimums ou maximums d'investissement ;",
          "à des procédures d'identification et de vérification (« KYC ») ;",
          "à des contrôles relatifs à la lutte contre le blanchiment de capitaux et le financement du terrorisme ;",
          "à la classification ou au profil de l'investisseur lorsque la réglementation applicable l'exige ;",
          "à la disponibilité de l'opportunité ;",
          "aux conditions fixées par l'émetteur, le fonds, la société concernée, le prestataire réglementé ou tout autre intervenant ;",
          "à la signature d'une documentation contractuelle et/ou réglementaire spécifique.",
        ],
      },
      {
        type: "p",
        text: "En cas de contradiction entre les présentes Conditions et la documentation spécifique relative à un investissement, cette dernière prévaut pour tout ce qui concerne l'investissement.",
      },
    ],
  },
  {
    num: 4,
    title: "Absence de conseil en investissement",
    blocks: [
      {
        type: "p",
        text: "Sauf indication expresse contraire et sous réserve des autorisations réglementaires éventuellement requises, les informations, présentations, documents, événements et contenus accessibles par l'intermédiaire d'ACE Fund ont une finalité informative et ne constituent pas un conseil personnalisé en investissement, une recommandation personnalisée, une garantie de rendement ou une garantie quant à l'opportunité d'un investissement.",
      },
      { type: "p", text: "Chaque membre reste responsable de ses propres décisions d'investissement." },
      {
        type: "p",
        text: "Le membre est invité à prendre connaissance de l'intégralité de la documentation relative à chaque opération envisagée et, lorsque cela est approprié, à solliciter ses propres conseillers financiers, juridiques, comptables ou fiscaux.",
      },
    ],
  },
  {
    num: 5,
    title: "Risques liés aux investissements",
    blocks: [
      { type: "p", text: "Tout investissement comporte des risques." },
      {
        type: "p",
        text: "Selon la nature de l'opération concernée, ces risques peuvent notamment comprendre une perte partielle ou totale du capital investi, une absence de liquidité, une durée de détention importante, une fluctuation de la valeur de l'investissement ou l'absence de distribution ou de rendement.",
      },
      {
        type: "p",
        text: "L'adhésion à ACE Fund ne constitue aucune garantie de performance, de rendement, de liquidité ou de récupération du capital investi.",
      },
      {
        type: "p",
        text: "Les risques spécifiques à chaque investissement sont décrits, le cas échéant, dans la documentation propre à l'opération concernée.",
      },
    ],
  },
  {
    num: 6,
    title: "Offre Private et fonds luxembourgeois",
    blocks: [
      {
        type: "p",
        text: "Lorsque la formule Private permet l'accès à une possibilité d'investissement dans un fonds établi au Luxembourg, l'adhésion à la formule Private ne constitue pas elle-même une souscription au fonds et ne garantit pas l'acceptation du membre en qualité d'investisseur.",
      },
      {
        type: "p",
        text: "Tout investissement dans ce fonds est exclusivement régi par la documentation juridique, financière et réglementaire propre au fonds ainsi que par les dispositions légales et réglementaires applicables.",
      },
      {
        type: "p",
        text: "L'investissement est notamment susceptible d'être soumis à des critères d'éligibilité, à un montant minimum de souscription, à des procédures KYC/AML et à l'acceptation finale du souscripteur par l'entité compétente.",
      },
      {
        type: "p",
        text: "En cas de contradiction entre les informations figurant sur la plateforme ACE Fund et la documentation officielle du fonds, cette dernière prévaut.",
      },
    ],
  },
  {
    num: 7,
    title: "Conditions d'adhésion",
    blocks: [
      {
        type: "p",
        text: "L'adhésion est ouverte aux personnes physiques majeures disposant de la capacité juridique nécessaire ainsi qu'aux personnes morales valablement constituées.",
      },
      {
        type: "p",
        text: "Lorsqu'une adhésion est souscrite au nom d'une personne morale, la personne procédant à la souscription déclare disposer des pouvoirs nécessaires pour engager celle-ci.",
      },
      {
        type: "p",
        text: "ACE Fund peut demander les informations raisonnablement nécessaires à la création et à la sécurisation du compte ainsi qu'au respect de ses obligations légales.",
      },
      {
        type: "p",
        text: "L'accès à certaines fonctionnalités ou opportunités peut être soumis à des vérifications supplémentaires.",
      },
    ],
  },
  {
    num: 8,
    title: "Souscription",
    blocks: [
      { type: "p", text: "L'adhésion est souscrite selon les modalités proposées sur le Site." },
      {
        type: "p",
        text: "Avant de confirmer son adhésion, le membre a la possibilité de prendre connaissance de la formule choisie, de son prix, de sa durée et des présentes Conditions.",
      },
      { type: "p", text: "La validation d'une commande payante implique l'obligation d'en acquitter le prix." },
      {
        type: "p",
        text: "La souscription devient définitive sous réserve du droit de rétractation applicable aux consommateurs et après confirmation de la commande et acceptation du paiement.",
      },
      {
        type: "p",
        text: "Le membre reçoit une confirmation de son adhésion sur un support durable, notamment par courrier électronique.",
      },
    ],
  },
  {
    num: 9,
    title: "Prix",
    blocks: [
      { type: "p", text: "Les prix des différentes adhésions sont ceux indiqués sur le Site au moment de la souscription." },
      {
        type: "p",
        text: "Sauf indication contraire, les prix présentés aux consommateurs sont exprimés toutes taxes comprises lorsque la TVA est applicable.",
      },
      {
        type: "p",
        text: "Les offres ACE Fund sont souscrites pour une période annuelle, à l'exception des formules pour lesquelles le Site prévoit expressément une autre périodicité.",
      },
      {
        type: "p",
        text: "La formule Investisseur peut notamment être proposée avec un paiement de 50 EUR par mois, selon les conditions affichées au moment de la souscription.",
      },
      {
        type: "p",
        text: "La mensualisation éventuelle d'une adhésion annuelle constitue, sauf indication contraire explicite lors de la souscription, une modalité de paiement de l'engagement annuel et non une succession de contrats mensuels indépendants.",
      },
      {
        type: "p",
        text: "Le prix applicable pendant une période d'adhésion en cours ne peut être modifié unilatéralement au détriment d'un consommateur, sauf dans les cas et conditions autorisés par la loi.",
      },
    ],
  },
  {
    num: 10,
    title: "Paiement",
    blocks: [
      { type: "p", text: "Le paiement est effectué au moyen des modes de paiement proposés sur le Site." },
      {
        type: "p",
        text: "Le membre s'engage à fournir des informations de paiement exactes et à disposer des autorisations nécessaires à l'utilisation du moyen de paiement sélectionné.",
      },
      {
        type: "p",
        text: "En cas de paiement échelonné d'une adhésion annuelle, l'échelonnement ne modifie pas la durée de l'engagement souscrit.",
      },
      {
        type: "p",
        text: "Les dispositions légales impératives relatives aux conséquences d'un défaut de paiement demeurent intégralement applicables.",
      },
    ],
  },
  {
    num: 11,
    title: "Durée",
    blocks: [
      {
        type: "p",
        text: "Sauf mention contraire sur le Site lors de la souscription, les adhésions sont conclues pour une durée déterminée de douze (12) mois à compter de leur prise d'effet.",
      },
      {
        type: "p",
        text: "Les conditions particulières présentées au membre lors de sa commande précisent si l'adhésion prend fin automatiquement à l'échéance ou si elle est susceptible d'être renouvelée.",
      },
    ],
  },
  {
    num: 12,
    title: "Renouvellement",
    blocks: [
      {
        type: "p",
        text: "Lorsqu'un renouvellement automatique est proposé à un consommateur, celui-ci est clairement informé, avant la conclusion du contrat, de l'existence de cette reconduction, de ses conséquences, de la date limite et des modalités permettant de s'y opposer ainsi que de son droit de résiliation après la reconduction conformément aux dispositions impératives du droit belge.",
      },
      {
        type: "p",
        text: "Les nouvelles conditions tarifaires éventuellement applicables à une nouvelle période d'adhésion sont communiquées avant leur entrée en vigueur dans les conditions prévues par la réglementation applicable.",
      },
    ],
  },
  {
    num: 13,
    title: "Résiliation par le membre",
    blocks: [
      {
        type: "p",
        text: "Le membre peut notifier à ACE Fund sa volonté de mettre fin à son adhésion selon les modalités indiquées sur le Site ou en contactant ACE Fund.",
      },
      {
        type: "p",
        text: "Lorsque l'adhésion est conclue pour une durée déterminée de douze mois, la résiliation anticipée demandée par le membre ne donne en principe pas lieu au remboursement prorata temporis des sommes correspondant à la période d'adhésion restant à courir, sauf disposition légale impérative contraire, manquement imputable à ACE Fund ou accord exprès d'ACE Fund.",
      },
      {
        type: "p",
        text: "Lorsqu'une adhésion annuelle fait l'objet d'un paiement mensuel, la cessation anticipée de l'utilisation du service ne libère pas automatiquement le membre des échéances correspondant à l'engagement annuel souscrit, sous réserve des droits impératifs dont bénéficie le consommateur.",
      },
      {
        type: "p",
        text: "Cette disposition est sans préjudice du droit légal de rétractation et des autres droits impératifs reconnus au consommateur.",
      },
    ],
  },
  {
    num: 14,
    title: "Droit de rétractation des consommateurs",
    blocks: [
      {
        type: "p",
        text: "Lorsqu'un membre ayant la qualité de consommateur conclut son adhésion à distance, notamment via le Site, il bénéficie, lorsque la loi le prévoit, d'un délai de quatorze (14) jours calendrier pour se rétracter sans devoir motiver sa décision.",
      },
      { type: "p", text: "Le délai court conformément aux dispositions légales applicables." },
      {
        type: "p",
        text: "Le consommateur peut exercer son droit de rétractation en adressant à ACE Fund, avant l'expiration du délai, le formulaire légal de rétractation ou toute autre déclaration dénuée d'ambiguïté exprimant sa volonté de se rétracter.",
      },
      {
        type: "p",
        text: "Lorsque le consommateur demande expressément que l'exécution des services commence avant l'expiration du délai de rétractation, les conséquences de cette demande sont celles prévues par la législation applicable.",
      },
      {
        type: "p",
        text: "Si le consommateur exerce valablement son droit de rétractation après avoir demandé le commencement de l'exécution du service, ACE Fund peut, lorsque la loi l'autorise, réclamer le montant proportionnel aux services effectivement fournis jusqu'à la communication de la décision de rétractation.",
      },
      {
        type: "p",
        text: "Les éventuels remboursements dus sont effectués conformément aux délais et modalités imposés par la législation applicable.",
      },
    ],
  },
  {
    num: 15,
    title: "Compte membre",
    blocks: [
      { type: "p", text: "L'accès à la plateforme peut nécessiter la création d'un compte personnel." },
      {
        type: "p",
        text: "Les identifiants sont personnels et confidentiels. Le membre s'engage à prendre les précautions raisonnables nécessaires afin d'empêcher tout accès non autorisé à son compte.",
      },
      {
        type: "p",
        text: "Le membre est responsable de l'exactitude des informations qu'il communique et s'engage à les actualiser lorsque cela est nécessaire.",
      },
      { type: "p", text: "Toute utilisation frauduleuse ou suspecte doit être signalée à ACE Fund dans les meilleurs délais." },
    ],
  },
  {
    num: 16,
    title: "Utilisation de la plateforme",
    blocks: [
      {
        type: "p",
        text: "Le membre s'engage à utiliser la plateforme conformément à sa destination et à la législation applicable.",
      },
      { type: "p", text: "Sont notamment interdits :" },
      {
        type: "ul",
        items: [
          "l'utilisation frauduleuse de la plateforme ;",
          "l'usurpation d'identité ;",
          "la transmission volontaire d'informations fausses ou trompeuses ;",
          "la tentative d'accès non autorisé aux systèmes ou données ;",
          "la copie ou diffusion non autorisée de contenus protégés ;",
          "l'utilisation de la plateforme dans le cadre d'activités illicites.",
        ],
      },
    ],
  },
  {
    num: 17,
    title: "Suspension ou suppression de l'accès",
    blocks: [
      {
        type: "p",
        text: "ACE Fund peut suspendre temporairement ou, lorsque cela est justifié, mettre fin à l'accès d'un membre en cas notamment :",
      },
      {
        type: "ul",
        items: [
          "de fraude ou suspicion raisonnable de fraude ;",
          "d'utilisation illicite de la plateforme ;",
          "d'atteinte à la sécurité de la plateforme ou de ses utilisateurs ;",
          "de violation grave ou répétée des présentes Conditions ;",
          "de défaut de paiement persistant ;",
          "de nécessité découlant d'une obligation légale ou réglementaire.",
        ],
      },
      {
        type: "p",
        text: "Lorsqu'il s'agit d'un consommateur, cette mesure est appliquée de manière proportionnée et sans préjudice de ses droits légaux.",
      },
      {
        type: "p",
        text: "Une résiliation imputable à ACE Fund ne peut avoir pour effet de priver le consommateur des droits ou remboursements auxquels il aurait droit en vertu de dispositions impératives.",
      },
    ],
  },
  {
    num: 18,
    title: "Disponibilité de la plateforme",
    blocks: [
      {
        type: "p",
        text: "ACE Fund met en œuvre des moyens raisonnables afin d'assurer la disponibilité et la sécurité de la plateforme.",
      },
      {
        type: "p",
        text: "Une disponibilité permanente et ininterrompue ne peut toutefois être garantie, notamment en cas de maintenance, mise à jour, incident technique, intervention d'un prestataire externe ou événement échappant raisonnablement au contrôle d'ACE Fund.",
      },
    ],
  },
  {
    num: 19,
    title: "Responsabilité",
    blocks: [
      { type: "p", text: "ACE Fund répond de l'exécution de ses obligations conformément au droit applicable." },
      {
        type: "p",
        text: "ACE Fund ne saurait toutefois être tenue responsable des pertes résultant exclusivement d'une décision d'investissement prise par un membre, de l'évolution économique d'une société ou d'un projet financé, des fluctuations de marché ou de la réalisation d'un risque inhérent à l'investissement et dûment communiqué à l'investisseur.",
      },
      {
        type: "p",
        text: "ACE Fund ne garantit ni le succès des projets présentés, ni la rentabilité d'un investissement, ni la récupération du capital investi.",
      },
      {
        type: "p",
        text: "Aucune disposition des présentes Conditions n'a pour objet ou pour effet d'exclure ou de limiter une responsabilité qui ne peut légalement être exclue ou limitée.",
      },
    ],
  },
  {
    num: 20,
    title: "Informations relatives aux opportunités",
    blocks: [
      { type: "p", text: "ACE Fund veille raisonnablement à la qualité des informations qu'elle communique elle-même." },
      {
        type: "p",
        text: "Certaines informations relatives aux opportunités peuvent toutefois provenir d'émetteurs, de sociétés, de fonds, de porteurs de projets ou de prestataires tiers.",
      },
      {
        type: "p",
        text: "Le membre doit se référer à la documentation officielle propre à chaque opération avant toute décision d'investissement.",
      },
    ],
  },
  {
    num: 21,
    title: "Fiscalité",
    blocks: [
      {
        type: "p",
        text: "Les conséquences fiscales d'une adhésion ou d'un investissement dépendent notamment de la situation personnelle du membre, de sa résidence fiscale et de la nature de l'opération.",
      },
      {
        type: "p",
        text: "Sauf mention expresse contraire, les informations mises à disposition par ACE Fund ne constituent pas un conseil fiscal.",
      },
      {
        type: "p",
        text: "Il appartient au membre de vérifier sa situation auprès d'un professionnel compétent lorsque cela est nécessaire.",
      },
    ],
  },
  {
    num: 22,
    title: "Propriété intellectuelle",
    blocks: [
      {
        type: "p",
        text: "Le Site, la plateforme, les marques, logos, textes, présentations, bases de données, éléments graphiques et autres contenus appartenant à ACE Fund ou utilisés avec autorisation sont protégés par les droits de propriété intellectuelle applicables.",
      },
      {
        type: "p",
        text: "L'adhésion confère uniquement un droit personnel, limité et non exclusif d'utiliser les services et contenus conformément à leur destination.",
      },
      {
        type: "p",
        text: "Toute reproduction, extraction, diffusion, commercialisation ou mise à disposition non autorisée est interdite, sous réserve des exceptions prévues par la loi.",
      },
    ],
  },
  {
    num: 23,
    title: "Confidentialité",
    blocks: [
      { type: "p", text: "Certaines informations communiquées aux membres peuvent être identifiées comme confidentielles." },
      {
        type: "p",
        text: "Le membre s'engage à ne pas divulguer ces informations à des tiers lorsqu'il a été clairement informé de leur caractère confidentiel, sauf autorisation, obligation légale ou nécessité liée à l'obtention d'un conseil professionnel lui-même soumis à une obligation appropriée de confidentialité.",
      },
    ],
  },
  {
    num: 24,
    title: "Données à caractère personnel",
    blocks: [
      {
        type: "p",
        text: "ACE Good traite les données à caractère personnel conformément au Règlement général sur la protection des données (« RGPD ») et à la législation belge applicable.",
      },
      {
        type: "p",
        text: "Les informations relatives notamment aux catégories de données traitées, finalités, bases juridiques, durées de conservation, destinataires et droits des personnes concernées figurent dans la politique de confidentialité disponible sur le Site.",
      },
    ],
  },
  {
    num: 25,
    title: "Modification des Conditions",
    blocks: [
      {
        type: "p",
        text: "ACE Fund peut modifier les présentes Conditions notamment afin de tenir compte d'une évolution législative ou réglementaire, d'une modification raisonnable des services ou de contraintes techniques ou de sécurité.",
      },
      {
        type: "p",
        text: "Les modifications affectant substantiellement les droits ou obligations d'un membre pendant une période contractuelle en cours lui sont communiquées sur un support durable dans un délai raisonnable avant leur entrée en vigueur.",
      },
      {
        type: "p",
        text: "Les droits impératifs permettant au consommateur de refuser certaines modifications ou de mettre fin au contrat demeurent applicables.",
      },
    ],
  },
  {
    num: 26,
    title: "Force majeure",
    blocks: [
      {
        type: "p",
        text: "Aucune partie ne peut être tenue responsable d'un manquement directement causé par un événement de force majeure au sens du droit belge, pendant la durée et dans la mesure où cet événement empêche effectivement l'exécution de l'obligation concernée.",
      },
      { type: "p", text: "Les parties prennent les mesures raisonnables permettant de limiter les conséquences de cet événement." },
    ],
  },
  {
    num: 27,
    title: "Nullité partielle",
    blocks: [
      {
        type: "p",
        text: "Si une disposition des présentes Conditions est déclarée nulle, invalide ou inapplicable, cette circonstance n'affecte pas les autres dispositions dans la mesure où le contrat peut subsister sans la disposition concernée.",
      },
      { type: "p", text: "Les dispositions légales impératives applicables remplacent, le cas échéant, la disposition invalide." },
    ],
  },
  {
    num: 28,
    title: "Réclamations",
    blocks: [
      {
        type: "p",
        text: "Toute question ou réclamation relative à une adhésion peut être adressée à ACE Good aux coordonnées indiquées sur le Site.",
      },
      { type: "p", text: "ACE Fund s'efforce de traiter les réclamations dans un délai raisonnable." },
      {
        type: "p",
        text: "Lorsqu'il agit en qualité de consommateur et qu'aucune solution amiable n'a pu être trouvée directement avec ACE Fund, le membre peut, lorsque les conditions applicables sont remplies, s'adresser au Service de Médiation pour le Consommateur.",
      },
    ],
  },
  {
    num: 29,
    title: "Droit applicable",
    blocks: [
      { type: "p", text: "Les présentes Conditions sont régies par le droit belge." },
      {
        type: "p",
        text: "Lorsque le membre est un consommateur, ce choix ne peut avoir pour effet de le priver de la protection que lui accordent les dispositions impératives qui lui seraient applicables.",
      },
    ],
  },
  {
    num: 30,
    title: "Juridictions compétentes",
    blocks: [
      {
        type: "p",
        text: "Tout litige relatif à la validité, l'interprétation ou l'exécution des présentes Conditions relève des juridictions compétentes conformément aux règles légales applicables.",
      },
      {
        type: "p",
        text: "Lorsque le membre agit en qualité de consommateur, aucune disposition des présentes Conditions ne limite son droit de saisir la juridiction compétente en vertu des règles impératives applicables.",
      },
      {
        type: "p",
        text: "Pour les membres professionnels, et sous réserve des dispositions impératives applicables, les tribunaux de l'arrondissement judiciaire de Liège sont compétents.",
      },
    ],
  },
];

const ARTICLES_EN = [
  {
    num: 1,
    title: "Identification",
    blocks: [
      {
        type: "p",
        text: "These General Terms of Membership (the “Terms”) govern the memberships offered under the ACE Fund brand by:",
      },
      {
        type: "address",
        lines: [
          "ACE Good SRL",
          "Private limited company under Belgian law",
          "Company / VAT number: BE 0776.527.659",
          "Registered office: Rue Fortemps de Loneux 25, 4000 Liège, Belgium",
          "Hereinafter “ACE Fund”, “ACE Good” or “we”.",
        ],
      },
      {
        type: "p",
        text: "Electronic contact details and, where applicable, other legal information are available on the website www.acefund.io (the “Site”).",
      },
    ],
  },
  {
    num: 2,
    title: "Purpose",
    blocks: [
      {
        type: "p",
        text: "These Terms set out the rights and obligations applicable to the subscription and use of the various ACE Fund membership plans.",
      },
      {
        type: "p",
        text: "Depending on the plan chosen, membership may in particular allow the member to:",
      },
      {
        type: "ul",
        items: [
          "access the ACE Fund platform and certain content, information and services reserved for members;",
          "take part in events, meetings, activities or services offered by ACE Fund;",
          "benefit from the advantages corresponding to the membership plan chosen;",
          "learn about investment opportunities offered or presented on the platform;",
          "where provided for by the relevant plan, access certain investment opportunities or structures, subject to meeting the specific conditions applicable thereto.",
        ],
      },
      {
        type: "p",
        text: "The exact content, benefits, price and any specific conditions of each plan are those presented on the Site at the time of subscription.",
      },
    ],
  },
  {
    num: 3,
    title: "Distinction between membership and investments",
    blocks: [
      {
        type: "p",
        text: "Membership of ACE Fund and the making of an investment are two legally distinct transactions.",
      },
      {
        type: "p",
        text: "Payment of a membership fee does not under any circumstances constitute an investment, a subscription to a financial instrument, or a transfer of funds intended to be invested.",
      },
      {
        type: "p",
        text: "Membership may give the member access to information relating to certain investment opportunities. Such access does not, however, confer any automatic right to participate in a given transaction.",
      },
      {
        type: "p",
        text: "Any investment transaction may in particular be subject to:",
      },
      {
        type: "ul",
        items: [
          "specific eligibility conditions;",
          "minimum or maximum investment thresholds;",
          "identification and verification (“KYC”) procedures;",
          "controls relating to the fight against money laundering and terrorist financing;",
          "the investor's classification or profile where required by applicable regulations;",
          "the availability of the opportunity;",
          "conditions set by the issuer, the fund, the company concerned, the regulated service provider or any other party involved;",
          "the signing of specific contractual and/or regulatory documentation.",
        ],
      },
      {
        type: "p",
        text: "In the event of a contradiction between these Terms and the specific documentation relating to an investment, the latter shall prevail with respect to all matters concerning the investment.",
      },
    ],
  },
  {
    num: 4,
    title: "No investment advice",
    blocks: [
      {
        type: "p",
        text: "Except where expressly stated otherwise and subject to any regulatory authorisations that may be required, the information, presentations, documents, events and content accessible through ACE Fund are provided for information purposes only and do not constitute personalised investment advice, a personalised recommendation, a guarantee of return, or a guarantee as to the merits of any investment.",
      },
      { type: "p", text: "Each member remains responsible for their own investment decisions." },
      {
        type: "p",
        text: "Members are invited to read the entirety of the documentation relating to each contemplated transaction and, where appropriate, to seek advice from their own financial, legal, accounting or tax advisers.",
      },
    ],
  },
  {
    num: 5,
    title: "Investment risks",
    blocks: [
      { type: "p", text: "Any investment involves risk." },
      {
        type: "p",
        text: "Depending on the nature of the transaction concerned, these risks may in particular include a partial or total loss of the capital invested, a lack of liquidity, a significant holding period, fluctuation in the value of the investment, or the absence of any distribution or return.",
      },
      {
        type: "p",
        text: "Membership of ACE Fund does not constitute any guarantee of performance, return, liquidity or recovery of the capital invested.",
      },
      {
        type: "p",
        text: "The risks specific to each investment are described, where applicable, in the documentation specific to the transaction concerned.",
      },
    ],
  },
  {
    num: 6,
    title: "Private plan and Luxembourg fund",
    blocks: [
      {
        type: "p",
        text: "Where the Private plan provides access to a possible investment in a fund established in Luxembourg, membership of the Private plan does not in itself constitute a subscription to the fund and does not guarantee the member's acceptance as an investor.",
      },
      {
        type: "p",
        text: "Any investment in this fund is governed exclusively by the fund's own legal, financial and regulatory documentation, as well as by the applicable legal and regulatory provisions.",
      },
      {
        type: "p",
        text: "The investment may in particular be subject to eligibility criteria, a minimum subscription amount, KYC/AML procedures, and final acceptance of the subscriber by the competent entity.",
      },
      {
        type: "p",
        text: "In the event of a contradiction between the information appearing on the ACE Fund platform and the fund's official documentation, the latter shall prevail.",
      },
    ],
  },
  {
    num: 7,
    title: "Membership conditions",
    blocks: [
      {
        type: "p",
        text: "Membership is open to natural persons of legal age with the necessary legal capacity, as well as to legal entities validly incorporated.",
      },
      {
        type: "p",
        text: "Where membership is subscribed on behalf of a legal entity, the person carrying out the subscription represents that they hold the necessary powers to bind that entity.",
      },
      {
        type: "p",
        text: "ACE Fund may request the information reasonably necessary to create and secure the account and to comply with its legal obligations.",
      },
      {
        type: "p",
        text: "Access to certain features or opportunities may be subject to additional verifications.",
      },
    ],
  },
  {
    num: 8,
    title: "Subscription",
    blocks: [
      { type: "p", text: "Membership is subscribed in accordance with the procedures offered on the Site." },
      {
        type: "p",
        text: "Before confirming their membership, the member has the opportunity to review the plan chosen, its price, its duration and these Terms.",
      },
      { type: "p", text: "Validation of a paid order entails the obligation to pay the price." },
      {
        type: "p",
        text: "The subscription becomes final subject to the right of withdrawal applicable to consumers and after confirmation of the order and acceptance of payment.",
      },
      {
        type: "p",
        text: "The member receives confirmation of their membership on a durable medium, in particular by email.",
      },
    ],
  },
  {
    num: 9,
    title: "Price",
    blocks: [
      { type: "p", text: "The prices of the various memberships are those indicated on the Site at the time of subscription." },
      {
        type: "p",
        text: "Unless otherwise stated, the prices shown to consumers are expressed inclusive of all taxes where VAT is applicable.",
      },
      {
        type: "p",
        text: "ACE Fund offers are subscribed for an annual period, except for plans for which the Site expressly provides for a different frequency.",
      },
      {
        type: "p",
        text: "The Investor plan may in particular be offered with a payment of EUR 50 per month, subject to the conditions displayed at the time of subscription.",
      },
      {
        type: "p",
        text: "Any monthly instalment arrangement for an annual membership constitutes, unless explicitly stated otherwise at the time of subscription, a method of payment for the annual commitment and not a series of independent monthly contracts.",
      },
      {
        type: "p",
        text: "The price applicable during a current membership period may not be unilaterally changed to the detriment of a consumer, except in the cases and under the conditions permitted by law.",
      },
    ],
  },
  {
    num: 10,
    title: "Payment",
    blocks: [
      { type: "p", text: "Payment is made using the payment methods offered on the Site." },
      {
        type: "p",
        text: "The member undertakes to provide accurate payment information and to hold the necessary authorisations to use the payment method selected.",
      },
      {
        type: "p",
        text: "In the event of instalment payment of an annual membership, the instalment arrangement does not alter the duration of the commitment subscribed.",
      },
      {
        type: "p",
        text: "The mandatory legal provisions relating to the consequences of a payment default remain fully applicable.",
      },
    ],
  },
  {
    num: 11,
    title: "Duration",
    blocks: [
      {
        type: "p",
        text: "Unless otherwise stated on the Site at the time of subscription, memberships are entered into for a fixed term of twelve (12) months from their effective date.",
      },
      {
        type: "p",
        text: "The specific conditions presented to the member when ordering specify whether the membership automatically ends on expiry or whether it may be renewed.",
      },
    ],
  },
  {
    num: 12,
    title: "Renewal",
    blocks: [
      {
        type: "p",
        text: "Where automatic renewal is offered to a consumer, the consumer is clearly informed, before the contract is concluded, of the existence of this renewal, its consequences, the deadline and the arrangements for objecting to it, as well as of their right of termination after renewal in accordance with the mandatory provisions of Belgian law.",
      },
      {
        type: "p",
        text: "Any new pricing conditions applicable to a new membership period are communicated before they take effect, in accordance with the conditions provided for by the applicable regulations.",
      },
    ],
  },
  {
    num: 13,
    title: "Termination by the member",
    blocks: [
      {
        type: "p",
        text: "The member may notify ACE Fund of their wish to end their membership in accordance with the procedures indicated on the Site or by contacting ACE Fund.",
      },
      {
        type: "p",
        text: "Where membership is entered into for a fixed term of twelve months, early termination requested by the member does not, in principle, give rise to a pro rata refund of the amounts corresponding to the remaining membership period, except where required by mandatory legal provisions, in the event of a breach attributable to ACE Fund, or with ACE Fund's express agreement.",
      },
      {
        type: "p",
        text: "Where an annual membership is paid monthly, early cessation of use of the service does not automatically release the member from the instalments corresponding to the annual commitment subscribed, subject to the mandatory rights enjoyed by the consumer.",
      },
      {
        type: "p",
        text: "This provision is without prejudice to the statutory right of withdrawal and the other mandatory rights afforded to consumers.",
      },
    ],
  },
  {
    num: 14,
    title: "Consumers' right of withdrawal",
    blocks: [
      {
        type: "p",
        text: "Where a member who is a consumer enters into their membership at a distance, in particular via the Site, they benefit, where provided for by law, from a period of fourteen (14) calendar days to withdraw without having to justify their decision.",
      },
      { type: "p", text: "The period runs in accordance with the applicable legal provisions." },
      {
        type: "p",
        text: "The consumer may exercise their right of withdrawal by sending ACE Fund, before the expiry of the period, the statutory withdrawal form or any other unambiguous statement setting out their decision to withdraw.",
      },
      {
        type: "p",
        text: "Where the consumer expressly requests that performance of the services begin before the expiry of the withdrawal period, the consequences of this request are those provided for by the applicable legislation.",
      },
      {
        type: "p",
        text: "If the consumer validly exercises their right of withdrawal after having requested that performance of the service begin, ACE Fund may, where permitted by law, claim the amount proportional to the services actually provided up to the time the decision to withdraw was communicated.",
      },
      {
        type: "p",
        text: "Any refunds due are made in accordance with the time limits and procedures imposed by the applicable legislation.",
      },
    ],
  },
  {
    num: 15,
    title: "Member account",
    blocks: [
      { type: "p", text: "Access to the platform may require the creation of a personal account." },
      {
        type: "p",
        text: "Login credentials are personal and confidential. The member undertakes to take reasonable precautions to prevent any unauthorised access to their account.",
      },
      {
        type: "p",
        text: "The member is responsible for the accuracy of the information they provide and undertakes to update it where necessary.",
      },
      { type: "p", text: "Any fraudulent or suspicious use must be reported to ACE Fund as soon as possible." },
    ],
  },
  {
    num: 16,
    title: "Use of the platform",
    blocks: [
      {
        type: "p",
        text: "The member undertakes to use the platform in accordance with its intended purpose and with applicable law.",
      },
      { type: "p", text: "The following are in particular prohibited:" },
      {
        type: "ul",
        items: [
          "fraudulent use of the platform;",
          "identity theft;",
          "the deliberate transmission of false or misleading information;",
          "attempting to gain unauthorised access to systems or data;",
          "unauthorised copying or distribution of protected content;",
          "using the platform in connection with unlawful activities.",
        ],
      },
    ],
  },
  {
    num: 17,
    title: "Suspension or termination of access",
    blocks: [
      {
        type: "p",
        text: "ACE Fund may temporarily suspend or, where justified, terminate a member's access in particular in the event of:",
      },
      {
        type: "ul",
        items: [
          "fraud or reasonable suspicion of fraud;",
          "unlawful use of the platform;",
          "a breach of the security of the platform or its users;",
          "a serious or repeated breach of these Terms;",
          "persistent payment default;",
          "necessity arising from a legal or regulatory obligation.",
        ],
      },
      {
        type: "p",
        text: "Where the member is a consumer, this measure is applied proportionately and without prejudice to their statutory rights.",
      },
      {
        type: "p",
        text: "Termination attributable to ACE Fund may not have the effect of depriving the consumer of the rights or refunds to which they would be entitled under mandatory provisions.",
      },
    ],
  },
  {
    num: 18,
    title: "Availability of the platform",
    blocks: [
      {
        type: "p",
        text: "ACE Fund uses reasonable means to ensure the availability and security of the platform.",
      },
      {
        type: "p",
        text: "Permanent and uninterrupted availability cannot, however, be guaranteed, in particular in the event of maintenance, updates, technical incidents, action by an external service provider, or an event reasonably beyond ACE Fund's control.",
      },
    ],
  },
  {
    num: 19,
    title: "Liability",
    blocks: [
      { type: "p", text: "ACE Fund is liable for the performance of its obligations in accordance with applicable law." },
      {
        type: "p",
        text: "However, ACE Fund may not be held liable for losses resulting exclusively from an investment decision made by a member, from the economic performance of a company or a financed project, from market fluctuations, or from the materialisation of a risk inherent to the investment that was duly disclosed to the investor.",
      },
      {
        type: "p",
        text: "ACE Fund does not guarantee the success of the projects presented, the profitability of any investment, or the recovery of the capital invested.",
      },
      {
        type: "p",
        text: "Nothing in these Terms is intended, or shall have the effect, to exclude or limit any liability that cannot legally be excluded or limited.",
      },
    ],
  },
  {
    num: 20,
    title: "Information relating to opportunities",
    blocks: [
      { type: "p", text: "ACE Fund takes reasonable care over the quality of the information it communicates itself." },
      {
        type: "p",
        text: "Some information relating to opportunities may, however, come from issuers, companies, funds, project promoters or third-party service providers.",
      },
      {
        type: "p",
        text: "The member must refer to the official documentation specific to each transaction before making any investment decision.",
      },
    ],
  },
  {
    num: 21,
    title: "Taxation",
    blocks: [
      {
        type: "p",
        text: "The tax consequences of a membership or an investment depend in particular on the member's personal situation, their tax residence and the nature of the transaction.",
      },
      {
        type: "p",
        text: "Unless expressly stated otherwise, the information made available by ACE Fund does not constitute tax advice.",
      },
      {
        type: "p",
        text: "It is the member's responsibility to check their situation with a qualified professional where necessary.",
      },
    ],
  },
  {
    num: 22,
    title: "Intellectual property",
    blocks: [
      {
        type: "p",
        text: "The Site, the platform, the trademarks, logos, texts, presentations, databases, graphic elements and other content belonging to ACE Fund or used with authorisation are protected by applicable intellectual property rights.",
      },
      {
        type: "p",
        text: "Membership confers only a personal, limited and non-exclusive right to use the services and content in accordance with their intended purpose.",
      },
      {
        type: "p",
        text: "Any unauthorised reproduction, extraction, distribution, commercial exploitation or making available is prohibited, subject to the exceptions provided for by law.",
      },
    ],
  },
  {
    num: 23,
    title: "Confidentiality",
    blocks: [
      { type: "p", text: "Certain information communicated to members may be identified as confidential." },
      {
        type: "p",
        text: "The member undertakes not to disclose such information to third parties where they have been clearly informed of its confidential nature, except with authorisation, where required by law, or where necessary to obtain professional advice from an adviser who is themselves subject to an appropriate duty of confidentiality.",
      },
    ],
  },
  {
    num: 24,
    title: "Personal data",
    blocks: [
      {
        type: "p",
        text: "ACE Good processes personal data in accordance with the General Data Protection Regulation (“GDPR”) and applicable Belgian legislation.",
      },
      {
        type: "p",
        text: "Information relating in particular to the categories of data processed, purposes, legal bases, retention periods, recipients and the rights of data subjects can be found in the privacy policy available on the Site.",
      },
    ],
  },
  {
    num: 25,
    title: "Amendment of the Terms",
    blocks: [
      {
        type: "p",
        text: "ACE Fund may amend these Terms, in particular to take account of legislative or regulatory developments, a reasonable change to the services, or technical or security constraints.",
      },
      {
        type: "p",
        text: "Amendments that substantially affect a member's rights or obligations during a current contractual period are communicated to the member on a durable medium within a reasonable time before they take effect.",
      },
      {
        type: "p",
        text: "The mandatory rights allowing a consumer to refuse certain amendments or to terminate the contract remain applicable.",
      },
    ],
  },
  {
    num: 26,
    title: "Force majeure",
    blocks: [
      {
        type: "p",
        text: "Neither party may be held liable for a failure directly caused by an event of force majeure within the meaning of Belgian law, for the duration and to the extent that such event actually prevents performance of the obligation concerned.",
      },
      { type: "p", text: "The parties shall take reasonable measures to limit the consequences of such an event." },
    ],
  },
  {
    num: 27,
    title: "Partial invalidity",
    blocks: [
      {
        type: "p",
        text: "If any provision of these Terms is declared null, invalid or unenforceable, this shall not affect the other provisions, to the extent that the contract can continue to exist without the provision concerned.",
      },
      { type: "p", text: "The applicable mandatory legal provisions shall replace, where applicable, the invalid provision." },
    ],
  },
  {
    num: 28,
    title: "Complaints",
    blocks: [
      {
        type: "p",
        text: "Any question or complaint relating to a membership may be addressed to ACE Good using the contact details indicated on the Site.",
      },
      { type: "p", text: "ACE Fund endeavours to handle complaints within a reasonable time." },
      {
        type: "p",
        text: "Where the member is acting as a consumer and no amicable solution has been found directly with ACE Fund, the member may, where the applicable conditions are met, refer the matter to the Consumer Mediation Service (Service de Médiation pour le Consommateur).",
      },
    ],
  },
  {
    num: 29,
    title: "Governing law",
    blocks: [
      { type: "p", text: "These Terms are governed by Belgian law." },
      {
        type: "p",
        text: "Where the member is a consumer, this choice may not have the effect of depriving them of the protection afforded by any mandatory provisions that would otherwise apply to them.",
      },
    ],
  },
  {
    num: 30,
    title: "Competent courts",
    blocks: [
      {
        type: "p",
        text: "Any dispute relating to the validity, interpretation or performance of these Terms falls within the jurisdiction of the competent courts in accordance with the applicable legal rules.",
      },
      {
        type: "p",
        text: "Where the member is acting as a consumer, nothing in these Terms limits their right to bring proceedings before the competent court under the applicable mandatory rules.",
      },
      {
        type: "p",
        text: "For professional members, and subject to applicable mandatory provisions, the courts of the judicial district of Liège shall have jurisdiction.",
      },
    ],
  },
];

const I18N = {
  fr: {
    title: "Conditions générales d'adhésion – ACE Fund",
    version: "Version du 1er septembre 2026",
    annexTitle: "Annexe – Modèle de formulaire de rétractation",
    articles: ARTICLES_FR,
    annexBody: (
      <>
        <p>À utiliser uniquement si vous souhaitez vous rétracter du contrat.</p>
        <p>À l'attention de :</p>
        <p className="cgv-address">
          ACE Good SRL – ACE Fund
          <br />
          Rue Fortemps de Loneux 25
          <br />
          4000 Liège
          <br />
          Belgique
          <br />
          E-mail : [ADRESSE E-MAIL À COMPLÉTER]
        </p>
        <p>
          Je/Nous ( ) vous notifie/notifions ( ) par la présente ma/notre (*)
          rétractation du contrat portant sur l'adhésion ACE Fund ci-dessous :
        </p>
        <p>Formule d'adhésion : ____________________</p>
        <p>Commandée le : ____________________</p>
        <p>Nom du/des consommateur(s) : ____________________</p>
        <p>Adresse du/des consommateur(s) : ____________________</p>
        <p>
          Signature du/des consommateur(s), uniquement en cas de notification
          sur papier :
        </p>
        <p>Date : ____________________</p>
        <p>(*) Biffer la mention inutile.</p>
      </>
    ),
  },
  en: {
    title: "General Terms of Membership – ACE Fund",
    version: "Version dated 1 September 2026",
    annexTitle: "Annex – Model withdrawal form",
    articles: ARTICLES_EN,
    annexBody: (
      <>
        <p>To be used only if you wish to withdraw from the contract.</p>
        <p>To:</p>
        <p className="cgv-address">
          ACE Good SRL – ACE Fund
          <br />
          Rue Fortemps de Loneux 25
          <br />
          4000 Liège
          <br />
          Belgium
          <br />
          Email: [EMAIL ADDRESS TO BE COMPLETED]
        </p>
        <p>
          I/We ( ) hereby give notice that I/we ( ) withdraw from the contract
          for the ACE Fund membership below:
        </p>
        <p>Membership plan: ____________________</p>
        <p>Ordered on: ____________________</p>
        <p>Name of consumer(s): ____________________</p>
        <p>Address of consumer(s): ____________________</p>
        <p>Signature of consumer(s), only in the case of notification on paper:</p>
        <p>Date: ____________________</p>
        <p>(*) Delete as appropriate.</p>
      </>
    ),
  },
};

function ArticleBlock({ block }) {
  if (block.type === "p") {
    return <p>{block.text}</p>;
  }
  if (block.type === "ul") {
    return (
      <ul>
        {block.items.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    );
  }
  if (block.type === "address") {
    return (
      <p className="cgv-address">
        {block.lines.map((line, i) => (
          <React.Fragment key={i}>
            {line}
            {i < block.lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </p>
    );
  }
  return null;
}

function Cgv() {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith("en") ? "en" : "fr";
  const content = I18N[lang];

  return (
    <div className="cgv-container fade-in">
      <div className="cgv-header">
        <h2>{content.title}</h2>
        <p className="cgv-version">{content.version}</p>
      </div>

      <div className="cgv-body">
        {content.articles.map((article) => (
          <section className="cgv-article" key={article.num}>
            <h3>
              {article.num}. {article.title}
            </h3>
            {article.blocks.map((block, i) => (
              <ArticleBlock block={block} key={i} />
            ))}
          </section>
        ))}

        <section className="cgv-article">
          <h3>{content.annexTitle}</h3>
          {content.annexBody}
        </section>
      </div>
    </div>
  );
}

export default Cgv;
